import BannersPage from "./BannersPage";

export default BannersPage;
